export const SUB_ROUTES = ["insights", "evaluation", "notes", "info"] as const;
export const TAB_WITH_ICON = ["insights", "evaluation"] as const;
